import { render, staticRenderFns } from "./QueryWidget.vue?vue&type=template&id=38b0d232&scoped=true"
import script from "./QueryWidget.vue?vue&type=script&lang=js"
export * from "./QueryWidget.vue?vue&type=script&lang=js"
import style0 from "./QueryWidget.vue?vue&type=style&index=0&id=38b0d232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0d232",
  null
  
)

export default component.exports